var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSections(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666687 4.33331H4.00002V0.333313H0.666687V4.33331ZM0.666687 8.99998H4.00002V4.99998H0.666687V8.99998ZM4.66669 8.99998H8.00002V4.99998H4.66669V8.99998ZM8.66669 8.99998H12V4.99998H8.66669V8.99998ZM4.66669 4.33331H8.00002V0.333313H4.66669V4.33331ZM8.66669 0.333313V4.33331H12V0.333313H8.66669Z",
    fill: "#1F8598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSections);
export default __webpack_public_path__ + "static/media/sections.c88cefe34f23d2538cb1caa306e3cc60.svg";
export { ForwardRef as ReactComponent };